import React, { useContext } from "react";
import { Drawer, Button, Typography, Empty } from "antd";
import { WishlistContext } from "../WishlistContext";
import { CartContext } from "../CartContext";
import { IconTrash, IconPlus, IconShoppingCart, IconX } from "@tabler/icons-react";
import { renderSafeText } from "../util/unitFormatter";
import SafeImage from "./SafeImage";
import "../css/cartDrawer.css";

const { Text, Title } = Typography;

const WishlistDrawer = ({ isOpen, onClose }) => {
    const { wishlist, toggleWishlist, loading } = useContext(WishlistContext);
    const { addToCart, cart } = useContext(CartContext);

    const wishlistItems = (wishlist?.products || []).filter(p => p !== null && p !== undefined);

    const isProductInCart = (productId) => {
        return cart?.items?.some(item => (item.product?._id || item.product) === productId);
    };

    const handleRemove = (productId) => {
        toggleWishlist(productId);
    };

    const handleAddToCart = (productId, product) => {
        addToCart(productId, 1, {}, {
            name: product.name,
            image: product.imageUrl || (product.images && product.images[0]) || product.thumbnail,
            price: product.price,
            mrp: product.mrp,
            shopId: product.shopId?._id || product.shopId || null,
        });
    };

    return (
        <Drawer
            title={
                <div className="cart-drawer-header">
                    <span className="cart-drawer-title">❤️ Your Wishlist ({wishlistItems.length} Items)</span>
                </div>
            }
            placement="right"
            onClose={onClose}
            open={isOpen}
            width={window.innerWidth < 576 ? '92%' : 450}
            className="cart-drawer-custom"
            closeIcon={<IconX size={20} />}
        >
            {wishlistItems.length > 0 ? (
                <div className="cart-drawer-content">
                    <div className="cart-items-list">
                        {wishlistItems.map((product, index) => {
                            const actualProduct = product.product || product;
                            const productId = actualProduct._id || actualProduct.id;
                            const inCart = isProductInCart(productId);

                            return (
                                <div key={productId || index} className="cart-drawer-item">
                                    <div className="cart-item-img-wrapper pcu-cursor-pointer" onClick={() => window.open(`/single/Products/${productId}`, '_blank')}>
                                        <SafeImage
                                            alt={renderSafeText(actualProduct.name)}
                                            src={actualProduct.imageUrl || (actualProduct.images && actualProduct.images[0]) || (actualProduct.thumbnail)}
                                            variant="thumbnail"
                                            className="cart-item-img"
                                            placeholderText={renderSafeText(actualProduct.name)}
                                        />
                                    </div>
                                    <div className="cart-item-info">
                                        <Text className="cart-item-name pcu-cursor-pointer" onClick={() => window.open(`/single/Products/${productId}`, '_blank')}>
                                            {renderSafeText(actualProduct.name)}
                                        </Text>

                                        <div className="cart-item-price-row" style={{ marginTop: 'auto' }}>
                                            <div className="cart-price-block">
                                                <Text strong>₹{actualProduct.price}</Text>
                                                {actualProduct.mrp > actualProduct.price && (
                                                    <Text delete className="cart-mrp">MRP ₹{actualProduct.mrp}</Text>
                                                )}
                                            </div>

                                            <div className="cart-item-actions-drawer">
                                                {inCart ? (
                                                    <Button
                                                        type="text"
                                                        size="small"
                                                        disabled
                                                        className="pcu-color-muted"
                                                    >
                                                        In Cart
                                                    </Button>
                                                ) : (
                                                    <Button
                                                        type="text"
                                                        size="small"
                                                        icon={<IconShoppingCart size={18} />}
                                                        className="pcu-color-primary"
                                                        onClick={() => handleAddToCart(productId, actualProduct)}
                                                        style={{ color: '#d61c4e' }}
                                                    />
                                                )}
                                                <Button
                                                    type="text"
                                                    icon={<IconTrash size={18} />}
                                                    className="cart-item-remove-btn-drawer"
                                                    onClick={() => handleRemove(productId)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            ) : (
                <div className="cart-empty-state">
                    <div style={{
                        width: 90, height: 90, borderRadius: '50%',
                        background: 'linear-gradient(135deg, #fff0f3 0%, #ffd6e0 100%)',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        margin: '0 auto 20px', boxShadow: '0 4px 16px rgba(214,28,78,0.15)'
                    }}>
                        <svg width="44" height="44" viewBox="0 0 24 24" fill="#d61c4e"
                            stroke="#d61c4e" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                        </svg>
                    </div>
                    <Title level={4} style={{ margin: 0 }}>Your wishlist is empty</Title>
                    <Text type="secondary">Browse products and heart them to add to your wishlist.</Text>
                    <Button type="primary" onClick={() => { onClose(); }} style={{ marginTop: 16 }}>
                        Continue Browsing
                    </Button>
                </div>
            )}
        </Drawer>
    );
};

export default WishlistDrawer;

